import { z } from "zod/v4";

import { AgencyDtoSchema, CreateAgencyDtoSchema } from "../../../dtos/agencies";

export const PutAgencyRequestBodySchema = z.object({
  agency: CreateAgencyDtoSchema,
});

export type PutAgencyRequestBodyType = z.infer<
  typeof PutAgencyRequestBodySchema
>;

export const PutAgencyRequestPathParamSchema = z.object({
  id: z.uuid().optional(),
});

export type PutAgencyRequestPathParamType = z.infer<
  typeof PutAgencyRequestPathParamSchema
>;

export const PutAgencyResponseBodySchema = z.object({
  agency: AgencyDtoSchema,
});

export type PutAgencyResponseBodyType = z.infer<
  typeof PutAgencyResponseBodySchema
>;
